import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { TiptapNodeType } from '../../tiptapTypes';

export type ChildTaskList = {
    node: ProseMirrorNode;
    /** The task list's offset within its parent node's content. */
    offset: number;
};

/**
 * Gets the task list held by a node, along with its offset - the nested list holding a task item's
 * sub-tasks, or the document's own list.
 */
export const getChildTaskList = (node: ProseMirrorNode): ChildTaskList | null => {
    let childTaskList: ChildTaskList | null = null;

    node.forEach((child, offset) => {
        if (child.type.name === TiptapNodeType.taskList) childTaskList = { node: child, offset };
    });

    return childTaskList;
};

/**
 * Gets the position at the end of a task list document's own list - where an appended task item
 * becomes its last top level task.
 *
 * Returns nothing for a document with no list at all, which the schema does not produce but a
 * partially loaded or damaged document can.
 */
export const getTaskListEndPosition = (doc: ProseMirrorNode): number | null => {
    const childTaskList = getChildTaskList(doc);

    if (!childTaskList) return null;

    // `offset` is the list node's own position within the doc; +1 steps inside it.
    return childTaskList.offset + 1 + childTaskList.node.content.size;
};
